/* eslint-disable @typescript-eslint/no-this-alias */
export { }

declare global {
  /**
   * @interface String
   * @description  Extencion del tipo de dato String
   */
  interface String {
    Capitalize(): string;
    CapitalizeAll(): string;
    isJSON(): boolean;
    hashCode: any;
    format(arg: any): string;
    isNullOrEmpty(): boolean;
  }
}

(function () {
  /**
   * @description Pone en mayuscula el primer caracter y el resto en minuscula.
 * @returns {string}
   */
  String.prototype.Capitalize = function (): string {
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
  }

  /**
   * @description Pone en mayuscula el prmer caracter y todos los caracters despues de cada espacio el rsto de los caracteres en minuscula.
 * @return {string}
   */
  String.prototype.CapitalizeAll = function (): string {
    const words: string[] = this.split(' ');
    words.forEach((v, i) => words[i] = v.Capitalize())
    return words.join(' ');
  }

  /**
   * @description Verifica si un string es JSON y si es valido.
 * @returns {boolean}
   */
  String.prototype.isJSON = function (): boolean {
    try {
      JSON.parse((this as string));
    } catch (e) {
      return false;
    }
    return true;
  }

  String.prototype.hashCode = function (): any {
    let hash: any = 0;
    let i: number;
    let chr: number;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
      chr = this.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  String.prototype.format = function (arg: any): string {
    let text = "";
    // itera a través de arguments
    for (let i = 0; i < arguments.length; i++) {
      // eslint-disable-next-line prefer-rest-params
      text = this.replace(`{${i}}`, arguments[i]);
    }
    return text;
  }

  String.prototype.isNullOrEmpty = function (): boolean {
    return this === null || this.trim().length === 0
  }
})();
